<template>
    <div style="text-align: center;">
        <avatar :contact="contact" :size="64" />
        <h1 style="font-size: 1.5rem; margin-top: .5rem; margin-bottom: 0;">{{ contact.primary_display_as }}</h1>
        <div style="font-size: .9rem; margin-bottom: 2rem;">
            <div v-if="contact.secondary_display_as">
                {{ contact.secondary_display_as }}
            </div>
            <div v-if="contact.email" style="color: #999;">{{ contact.email }}</div>
            <div v-if="contact.primary_telephone" style="color: #999;">{{ contact.primary_telephone }}</div>
            <div v-if="contact.alternate_telephone" style="color: #999;">{{ contact.alternate_telephone }}</div>
            <div v-if="shouldShowPostCode">
                <a :href="`https://www.google.com/maps/place/${contact.post_code}`" target="_blank" class="badge badge-secondary">
                    <span class="material-icons" style="font-size: 12px;vertical-align: bottom;">mail</span>
                    {{ contact.post_code }}
                </a>
            </div>
            <div style="margin-top: 1rem;">
                <secondary-pill-button @click="$root.navigateTo(contactUrl)">View Contact</secondary-pill-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contact: {
            type: Object,
            required: true
        },
        shouldShowPostCode: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        contactUrl() {
            return 'contacts/' + this.contact.id
        }
    }
}
</script>

<style scoped>

</style>